module.exports = "<div class=\"hidden-div\" *ngFor=\"let sp of listaSP\">\n    <iframe [src]=\"sp\" title=\"External SP\"></iframe> \n</div>   "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/external-sp/external-sp.component.html
// module id = ./src/app/components/external-sp/external-sp.component.html
// module chunks = main